import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import EventGatePage from "./pages/EventGatePage.vue";
import NotFoundPage from "./pages/NotFoundPage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: "/events/:eventId",
    name: "event-gate",
    component: EventGatePage,
    props: (route) => ({ eventId: route.params["eventId"] }),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFoundPage,
  },
];

if (import.meta.env.DEV) {
  // Dev-only preview for ErrorScreen states without going through OTP.
  // Try /debug/error/subscription_required (or any other GateErrorCode).
  routes.unshift({
    path: "/debug/error/:code",
    name: "debug-error",
    component: () => import("./pages/DebugErrorPage.vue"),
    props: true,
  });
}

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
